import createConsts from '../../utils/redux/consts';
import { consts as logout } from '../auth/logout';
import { createActions } from '../../utils/redux';

export const consts = createConsts('context', 'teamUser', 'ADD', 'ADD_TEAM_ID');
export const actions = createActions(consts);

const initialState = { user: null, selectedTeamId: null };

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.ADD:
      return {
        ...state,
        user: payload,
      };
    case consts.ADD_TEAM_ID:
      return {
        ...state,
        selectedTeamId: payload,
      };
    case logout.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/context/team-user.js